import { Component, OnInit } from '@angular/core';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';

@Component({
  selector: 'app-exam-url',
  templateUrl: './exam-url.component.html',
  styleUrls: ['./exam-url.component.scss']
})
export class ExamUrlComponent implements OnInit {
  exam: IExam = examDefault;

  examUrl = "";
  selfDate: any;
  constructor(private popoverRef: PopoverRef<ExamUrlComponent>,
    private examService: ExamService,) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];

      await this.examService.getExamRegURL(this.exam.id).then((u: any) => {
        this.examUrl = u.url;

        this.selfDate = this.GetLocalTime(u.selfenddate);
      });
    }
  }

  GetLocalTime(date: any) {
    const localDate = new Date(date);
    localDate.setMinutes(localDate.getMinutes() - new Date().getTimezoneOffset());
    return localDate;
  }
  close() {
    this.popoverRef.close();
  }
}
